import { FormattedMessage } from 'react-intl';

import type { FiltersGroup } from '@sorare/core/src/lib/filters';
import {
  cardAttributes,
  glossary,
  navLabels,
} from '@sorare/core/src/lib/glossary';

import {
  BackendRefineCompetitionEligibility,
  RefineBackendAverageScore,
  RefineBackendPosition,
  RefineCompetitionEligibility,
  RefinePosition,
} from 'searchCards';
import { BackendGameweekFilter } from 'searchCards/FixtureFilter';
import { RefineBackendCardPlayerAge } from 'searchCards/RefineAge';
import { RefineBackendAppearances } from 'searchCards/RefineAppearances';
import { RefineBackendActiveClub } from 'searchCards/RefineClubs';
import {
  RefineBackendActiveLeague,
  RefineBackendActiveNationalTeam,
  RefineBackendNationality,
  RefineBackendPlayer,
  RefineBackendPlayingStatus,
} from 'searchCards/RefineList';
import { MatchInfoGroup, PlayerGroup } from 'searchCards/football/cardFilters';

import { BackendFloorPricesGroup, FloorPricesGroup } from './common';

export const CompetitionEligibilityGroup = {
  slug: 'eligibility',
  title: <FormattedMessage {...navLabels.gamingCompetitions} />,
  filters: [RefineCompetitionEligibility],
};

export const BackendCompetitionEligibilityGroup = {
  slug: 'eligibility',
  title: <FormattedMessage {...navLabels.gamingCompetitions} />,
  filters: [BackendRefineCompetitionEligibility],
};

export const scoutingCenterMarketFilters: FiltersGroup[] = [
  FloorPricesGroup,
  PlayerGroup({
    withPositions: true,
    withPlayingStatus: true,
  }),
  MatchInfoGroup,
];

export const scoutingCenterBackendMarketFilters: FiltersGroup[] = [
  BackendFloorPricesGroup,
  {
    slug: 'player',
    title: <FormattedMessage {...cardAttributes.player} />,
    filters: [
      RefineBackendPosition(),
      RefineBackendPlayingStatus,
      RefineBackendCardPlayerAge,
      RefineBackendNationality,
      RefineBackendPlayer,
      RefineBackendActiveLeague(),
      RefineBackendActiveClub(),
      RefineBackendActiveNationalTeam,
    ].filter(Boolean),
  },
  {
    slug: 'match-info',
    title: <FormattedMessage {...glossary.matchInfo} />,
    filters: [
      BackendGameweekFilter,
      RefineBackendAverageScore(),
      RefineBackendAppearances(),
    ],
  },
];

export const scoutingCenterMarketDropdownFilters = [RefinePosition()];
export const scoutingCenterBackendMarketDropdownFilters = [
  RefineBackendPosition(),
];
